module.exports = __webpack_public_path__ + "static/commercialthumb-580d1e814c42f6b1e5e34fa70fb29625.jpg";